import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BehaviorSubject } from 'rxjs';

interface IInformationDialogData {
	filePath: string;
}

@Component({
	selector: "kt-information-dialog",
	templateUrl: "./information-dialog.component.html",
	styleUrls: ["./information-dialog.component.scss"],
})
export class InformationDialogComponent implements OnInit {
	pageLoading$: BehaviorSubject<boolean>;
	innerFile: string = '';

	constructor(
		public dialogRef: MatDialogRef<InformationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: IInformationDialogData
	) {
		this.pageLoading$ = new BehaviorSubject<boolean>(true);
	}

	ngOnInit() {
		this.loadInfoFile(this.data.filePath);

	}

	async loadInfoFile(path: string) {
		this.innerFile = await fetch(path).then(r => r.text());
		this.pageLoading$.next(false);
	}
}
